<template>
    <div class="input-group">
        <span class="input-group-prepend" v-if="phone && allow_call"><button @click="$emit('call')" class="btn btn-outline-tertiary" type="button"><phone-outgoing-icon class="align-middle"></phone-outgoing-icon></button></span>
        <input v-show="!show_edit" :id="'placeholder' + _uid" :name="'placeholder' + _uid" readonly type="text" class="form-control" v-model="phoneView">
        <input v-if="allow_editing" v-show="show_edit" :id="'phone_input' + _uid" :name="'phone_input' + _uid" type="tel" class="form-control" v-model="phone_temp" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}">
        <span class="input-group-append" v-if="allow_editing">
            <button v-if="!show_edit" class="btn btn-outline-tertiary" @click="show_edit = true" type="button"><i class="fas fa-pen"></i></button>
            <button v-if="show_edit" class="btn btn-outline-tertiary" @click="save" type="button"><i class="fas fa-check"></i></button>
            <button v-if="show_edit" class="btn btn-outline-tertiary" @click="close" type="button"><i class="fas fa-times"></i></button>
        </span>
    </div>
</template>

<script>
import {PhoneOutgoingIcon} from 'vue-feather-icons';
export default {
    name: "PhoneField",
    components: {PhoneOutgoingIcon},
    props: {
        value: {
            required: true,
        },
        allow_editing: {
            type: Boolean,
            required: true,
        },
        allow_call: {
            type: Boolean,
            required: true,
        },
        use_validate: {
            type: Boolean,
            default: true,
        },
        hide_part_phone: {
            type: Boolean,
            default: true,
        }
    },
    data: () => ({
        phone: null,
        phone_temp: '',
        show_edit: false,
    }),
    mounted() {
        this.phone = this.value;
    },
    watch: {
        phone(val) {
            this.$emit('input', val !== null && val.length ? val : null);
        }
    },
    computed: {
        phoneView() {
            if (this.phone !== null && this.phone.length) {
                return this.hide_part_phone ? this.$hidePartPhone(this.phone) : this.phone;
                // return this.$formatPhone(this.$hasPermission('request.phone.show_full') ? this.$hidePartPhone(this.phone) : this.$hidePartPhone(this.phone))
            }
            return '';
        }
    },
    methods: {
        preparePhone (p) {
            return p.replace(/[^\+0-9]/g, '');
        },
        validatePhone (p) {
            if (!this.use_validate) return true;
            return p.slice(0,2) === '+7' && p.length === 12;
        },
        save() {
            let p = this.preparePhone(this.phone_temp);
            if (this.validatePhone(p) || !p) {
                this.phone = p;
            }
            this.close();
        },
        close() {
            this.phone_temp = '';
            this.show_edit = false;
        }
    }
}
</script>

<style scoped>

</style>
